import React from 'react';

export const PatientSummaryHeader = ({
  patient,
  layoutFormat,
  onChangeLayout,
  onBackToList,
}) => {
  if (!patient) return null;

  const isApproved = patient.tests?.every((t) => t.approved === 1);
  const isDraft = patient.tests?.some((t) => t.resultFlag === 1 && t.approved === 0);
  const hasCritical = patient.tests?.some((t) => t.hasCriticalResult);

  const statusBadge = isApproved ? (
    <span className="path-status-badge status-approved">Approved</span>
  ) : isDraft ? (
    <span className="path-status-badge status-draft">Draft</span>
  ) : (
    <span className="path-status-badge status-pending">Pending</span>
  );

  return (
    <div className="path-summary-header-card">
      <div className="path-summary-top-row">
        {/* Left: Back & Patient Name */}
        <div className="path-summary-title-group">
          <button
            type="button"
            className="path-btn path-btn-secondary path-btn-back"
            onClick={onBackToList}
            title="Return to Patient Worklist"
          >
            ← Back to Worklist
          </button>
          <div className="path-summary-patient-meta">
            <h2 className="path-summary-patient-name">{patient.patientName}</h2>
            <div className="path-summary-badges">
              <span className="path-info-pill">{patient.ageGender || 'Age: N/A'}</span>
              <span className="path-info-pill">UHID: {patient.patientId || '—'}</span>
              <span className="path-info-pill">Lab No: {patient.ledgerTransactionNo}</span>
              <span className="path-info-pill path-info-pill-panel" title="Patient Registration Panel">
                🏢 {patient.panelName || 'Direct Walk-In'}
              </span>
              {statusBadge}
              {hasCritical && (
                <span className="path-status-badge status-critical">⚠️ CRITICAL</span>
              )}
            </div>
          </div>
        </div>

        {/* Right: Layout Format Configurator */}
        <div className="path-layout-config-box">
          <span className="path-layout-label">View Layout:</span>
          <div className="path-layout-toggle-group">
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'tab-wise' ? 'active' : ''}`}
              onClick={() => onChangeLayout('tab-wise')}
              title="Format 1: Tab-Wise Result Entry"
            >
              📑 Tab-Wise
            </button>
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'stacked' ? 'active' : ''}`}
              onClick={() => onChangeLayout('stacked')}
              title="Format 2: Stacked One-Page Result Entry"
            >
              📜 Stacked One-Page
            </button>
            <button
              type="button"
              className={`path-layout-btn ${layoutFormat === 'compact' ? 'active' : ''}`}
              onClick={() => onChangeLayout('compact')}
              title="Format 3: Compact Grid + Detail Panel"
            >
              🗂️ Compact Grid
            </button>
          </div>
        </div>
      </div>

      {/* Detail Grid */}
      <div className="path-summary-details-grid">
        <div className="path-summary-item">
          <span className="lbl">Barcode / Accession:</span>
          <span className="val barcode-val">{patient.barcodeNo || '—'}</span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Sample Type:</span>
          <span className="val">{patient.sampleTypeName || 'Blood / Serum'}</span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Sample Received:</span>
          <span className="val">
            {patient.sampleReceiveDate
              ? new Date(patient.sampleReceiveDate).toLocaleString()
              : '—'}
          </span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Referring Doctor:</span>
          <span className="val">{patient.doctorName || 'Self / Walk-in'}</span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Department:</span>
          <span className="val">{patient.departmentName || 'Pathology & Biochemistry'}</span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Registration Panel:</span>
          <span className="val highlight-val">{patient.panelName || 'Direct Walk-In'}</span>
        </div>
        <div className="path-summary-item">
          <span className="lbl">Assigned Tests:</span>
          <span className="val highlight-val">{patient.tests?.length || 1} Investigation(s)</span>
        </div>
      </div>
    </div>
  );
};

export default PatientSummaryHeader;
